import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import Seo from '@/components/Seo';
import { homeSchema } from '@/lib/seo';
import Hero from './components/Hero';
import StatsStrip from './components/StatsStrip';
import WaysToWork from './components/WaysToWork';
import RoiCalculator from './components/RoiCalculator';
import LeadsSystem from './components/LeadsSystem';
import WhoFor from './components/WhoFor';
import CaseStudies from './components/CaseStudies';
import WhyJoshua from './components/WhyJoshua';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);

      const t = setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: 'smooth',
        });
      }, 120);

      return () => clearTimeout(t);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Seo
        title="Josh Hastings | Home Service Marketing & Growth Strategy"
        description="Josh Hastings helps established home-service businesses turn marketing spend into measurable leads, customers, and revenue through smarter marketing systems, lead generation, paid ads, automation, and growth strategy."
        canonical="https://joshuawhastings.com/"
      />

      <JsonLd data={homeSchema} />

      <Header />

      <main>
        <Hero />
        <StatsStrip />
        <WaysToWork />
        <RoiCalculator />
        <LeadsSystem />
        <WhoFor />
        <CaseStudies />
        <WhyJoshua />
        <Testimonials />
        <FinalCTA />
      </main>

      <Footer />
    </div>
  );
}
